import _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import * as CampaignActions from './campaign.actions';
import * as OptionActions from './option.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const optionFeatureKey = 'option';

export interface State extends EntityState<any> {
  search: string;
  selected: any;
}

export const adapter: EntityAdapter<any> = createEntityAdapter<any>();

export const initialState: State = adapter.getInitialState({
  search: '',
  selected: null
});

export const reducer = createReducer(
  initialState,

  on(OptionActions.setPresetOptionList, (state, action) => {
    return adapter.upsertMany(action.data, adapter.removeAll(state));
  }),
  on(OptionActions.setPresetOptionListSuccess, state => state),
  on(OptionActions.setPresetOptionListFailure, state => state),

  on(OptionActions.resetPresetOptionList, (state, action) => {
    return adapter.removeAll(state);
  }),
  on(OptionActions.resetPresetOptionListSuccess, state => state),
  on(OptionActions.resetPresetOptionListFailure, state => state),

  on(OptionActions.createPresetOption, state => state),
  on(OptionActions.createPresetOptionSuccess, state => state),
  on(OptionActions.createPresetOptionFailure, state => state),

  on(OptionActions.updatePresetOption, state => state),
  on(OptionActions.updatePresetOptionSuccess, state => state),
  on(OptionActions.updatePresetOptionFailure, state => state),

  on(OptionActions.deletePresetOption, state => state),
  on(OptionActions.deletePresetOptionSuccess, state => state),
  on(OptionActions.deletePresetOptionFailure, state => state),

  on(OptionActions.selectPresetOption, (state, { selected }) => {
    return { ...state, selected };
  }),
  on(OptionActions.selectPresetOptionSuccess, state => state),
  on(OptionActions.selectPresetOptionFailure, state => state),

  on(OptionActions.unselectPresetOption, state => {
    return { ...state, selected: null };
  }),
  on(OptionActions.unselectPresetOptionSuccess, state => state),
  on(OptionActions.unselectPresetOptionFailure, state => state),

  on(CampaignActions.newAddCampaignPresetOption, (state, { payload: { option } }) => {
    return adapter.upsertOne(option, state);
  }),

  on(CampaignActions.newCreateCampaignPresetOptionSuccess, (state, { data: option }) => {
    return adapter.upsertOne(option, state);
  }),

  on(CampaignActions.newUpdateCampaignPresetOptionSuccess, (state, { data: option }) => {
    return adapter.updateOne({
      id: option.id,
      changes: option
    }, state);
  }),

  on(CampaignActions.newDeleteCampaignPresetOptionSuccess, (state, { option }) => {
    const deleted = 1;
    const result = adapter.updateOne({id: option.id, changes: {status: deleted}}, state);

    return result;
  }),

  on(CampaignActions.restoreCampaignPresetOption, state => state),
  on(CampaignActions.restoreCampaignPresetOptionSuccess, (state, { option }) => {
    const active = 0;
    const result = adapter.updateOne({id: option.id, changes: {status: active}}, state);

    return result;
  }),
  on(CampaignActions.restoreCampaignPresetOptionFailure, (state, action) => state),

  on(CampaignActions.updatePresetOptionSearch, (state, action) => {
    return { ...state, search: action.payload };
  }),
);

